/* eslint-disable react/jsx-no-target-blank */
import React from 'react';
import PropTypes from 'prop-types';
import {computed } from 'mobx';
import {observer, inject} from 'mobx-react';
import {withRouter} from 'react-router';

import LogoWhite from 'spa/Components/Footer/LogoWhite';
import CountrySelect from 'spa/Components/Header/CountrySelect';
import ProgressiveImage from 'spa/Components/ProgressiveImage';
import {withConfig, withI18n} from 'spa/Components/Context';

import './landing-footer.less';

import SocialLinks from 'spa/Components/Footer/SocialLinks';

@withRouter
@inject(({store: {landingData, navigation}}) => (
  {
    landingData,
    navigation,
  }
))
@observer
@withI18n
@withConfig
class LandingFooter extends React.Component {
  static propTypes = {
    landingData: PropTypes.object,
    navigation: PropTypes.shape({
      footer: PropTypes.object.isRequired,
    }).isRequired,
  };

  UNSAFE_componentWillMount() {
    const {config, i18n} = this.context;
    const {landingData} = this.props;

    if (landingData) {
      this.downloadAppsLink = config.getValue('locale.adjust-landing-page-app-url', i18n.umRegion);
    } else {
      this.downloadAppsLink = config.getValue('locale.adjust-app-url', i18n.umRegion);
    }

    this.showFRDisclaimer = config.getValue('locale.show-fr-disclaimer', i18n.umRegion);
  }

  @computed get footerLinks() {
    const { navigation: { footer } } = this.props;
    const cmsSections = footer.navigations;
    return cmsSections.map(section => (
      <div className="landing-footer__section col-md-4 col-xs-6" key={section.title.replace(/\s+/g, '-').toLowerCase()}>
        <h4 className="landing-footer__section-title">{section.title}</h4>
        <ul>
          {section.navigation.map(navItem => (
            <li key={`${navItem.title.replace(/\s+/g, '-').toLowerCase()}`}>
              <a
                className="landing-footer__section-link"
                href={navItem.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                {navItem.title}
              </a>
            </li>
          ))}
        </ul>
      </div>
    ));
  }

  render() {
    const {i18n} = this.context;
    const {
      downloadAppsLink,
      showFRDisclaimer,
      footerLinks,
    } = this;

    return (
      <div className="landing-footer">
        <div className="container container--no-gutter">
          <div className="landing-footer__inner row">
            {footerLinks}
          </div>
          <div className="landing-footer__copyright">
            <div className="row">
              <div className="col-md-4 landing-footer__copyright--align-left" >
                <LogoWhite
                  className="landing-footer__logo" />
                <CountrySelect
                  fromTop
                  zIndex={11}
                  light />
              </div>
              <div className="col-md-4">
                <a
                  className="landing-footer__store-image"
                  href={downloadAppsLink}
                  id="js-landing-footer-download-on-the-app-store"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <ProgressiveImage
                    alt=""
                    lowResImg={i18n._x('https://res.cloudinary.com/huxr6hrje/image/upload/f_auto/v1495118209/home-en/appstore_en.svg', 'Appstore Image URL')}
                    height="40"
                    highResImg={i18n._x('https://res.cloudinary.com/huxr6hrje/image/upload/f_auto,w_135/v1495118209/home-en/appstore_en.svg', 'Appstore Image URL')}
                    highResImg2x={i18n._x('https://res.cloudinary.com/huxr6hrje/image/upload/f_auto,w_270/v1495118209/home-en/appstore_en.svg', 'Appstore Image URL')}
                    width="135"
                  />
                </a>
                <a
                  className="landing-footer__store-image landing-footer__store-image--no-margin"
                  href={downloadAppsLink}
                  id="js-landing-footer-download-on-the-google-play"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <ProgressiveImage
                    alt=""
                    lowResImg={i18n._x('https://res.cloudinary.com/huxr6hrje/image/upload/f_auto/v1495117099/home-en/optimised/gplay_en.png', 'PlayStore Image URL')}
                    height="40"
                    highResImg={i18n._x('https://res.cloudinary.com/huxr6hrje/image/upload/f_auto,w_135/v1495117099/home-en/optimised/gplay_en.png', 'PlayStore Image URL')}
                    highResImg2x={i18n._x('https://res.cloudinary.com/huxr6hrje/image/upload/f_auto,w_270/v1495117099/home-en/optimised/gplay_en.png', 'PlayStore Image URL')}
                    width="135"
                  />
                </a>
                {i18n.region === 'GB' && (
                  <p className="landing-footer__rights">&copy; {i18n._x('Urban Massage Ltd. All rights reserved.', 'GB - Footer copyright')}</p>
                )}
                {i18n.region === 'FR' && (
                  <p className="landing-footer__rights">&copy; {i18n._x('Urban Massage SARL. All rights reserved.', 'FR - Footer copyright')}</p>
                )}
              </div>
              <div className="col-md-4 landing-footer__copyright--align-right">
                <SocialLinks />
              </div>
            </div>
          </div>
          {showFRDisclaimer &&
            <div>
              <p className="landing-footer__bottom-fr-disclaimer">
                {i18n._x('Le terme « massage » ne correspond aucunement à la définition légale donnée par les dispositions règlementaires de l’article R. 4321-3 du Code de la Santé Publique (Décret n° 2004-802 du 29 juillet 2004 - JO du 8 août 2004).', 'French disclaimer footer part 1')}
                <br />
                {i18n._x('Il est rappelé que les massages médicaux, sportifs ou thérapeutiques ne peuvent être réalisés que par des médecins ou masseurs kinésithérapeutes', 'French disclaimer footer part 2')}
              </p>
            </div>
          }
        </div>
      </div>
    );
  }
}

export default LandingFooter;



// WEBPACK FOOTER //
// ./spa/Pages/Landing/Verticals/Components/LandingFooter.jsx